<template>
  <div v-if="open" class="test">
    <video
      ref="video"
      class="video"
      v-if="showVideo"
      v-show="!minimized"
      @canplay="onVideoLoaded"
      @ended="onVideoEnded"
    >
      <source :src="video" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
    <base-dialog-component
      :showInfoIcon="false"
      :showClose="true"
      :showMinimize="true"
      :open="open"
      :title="$t(title)"
      :body="$t(body)"
      bodyType="text"
      @togglePopup="togglePopup"
      @closeDialog="closeClick"
      :height="videoHeight"
      width="600px"
      right="50px"
      bottom="50px"
      :opacity="0.9"
      fontSizeBody="18px"
      :center="false"
    ></base-dialog-component>
  </div>
</template>
<script>
import { setCancelAnimation } from "@/scenes/MyFirstScene";
import baseComponent from "./baseComponent.vue";

export default {
  name: "testComponent",
  components: {
    baseDialogComponent: baseComponent,
  },
  data() {
    return {
      video: null,
      videoLoaded: null,
      resolveDialog: null,
      open: false,
      title: null,
      body: null,
      slideBody: 0, // TODO
      showVideo: false,
      testEnded: false,
      videoEnded: false,
      minimized: false,
    };
  },
  beforeMount() {
    this.$root.$on("startTest", this.startTest);
    this.$root.$on("eventScene", this.eventScene);
  },
  beforeDestroy() {
    this.$root.$off("startTest", this.startTest);
    this.$root.$off("eventScene", this.eventScene);
  },
  computed: {
    videoHeight() {
      const width = Math.min(window.innerWidth / 2, 800);
      return `${(width * 1080) / 1920}px`;
    },
    lab() {
      return this.$store.getters.getCurrentLab;
    },
  },
  methods: {
    eventScene({ key, value, resolve }) {
      switch (key) {
        case "showSpinner":
          this.showSpinner(value);
          break;
        case "previousSlide":
          this.previousSlide();
          break;
        case "nextSlide":
          this.nextSlide();
          break;
        case "changeSlide":
          this.changeSlide(value);
          break;
        case "playVideo":
          this.playVideo(resolve);
          break;
        case "displayVideo":
          this.displayVideo({ value, resolve });
          break;
        case "close":
          this.close(value);
          break;

        default:
          break;
      }
    },
    showSpinner(value) {
      this.$store.dispatch("setSpinner", { loading: value });
    },
    previousSlide() {
      const length = this.body.split("\n\n").length;

      this.slideBody--;
      this.slideBody = (this.slideBody + length) % length;
    },
    nextSlide() {
      const length = this.body.split("\n\n").length;

      this.slideBody++;
      this.slideBody = (this.slideBody + length) % length;
    },
    changeSlide(value) {
      this.slideBody = value;
    },
    displayVideo({ value, resolve }) {
      this.showVideo = value;
      this.videoLoaded = resolve;
    },
    async playVideo(resolve) {
      const video = this.$refs.video;
      await video.play();
      resolve();
      console.log("Video start");
    },
    onVideoLoaded() {
      const video = this.$refs.video;

      if (video) {
        // video.currentTime = 0;

        if (process.env.NODE_ENV === "development") {
          video.playbackRate = window.speedFactor || 1;
        }
      }

      if (this.videoLoaded) {
        console.log("Video loaded");
        this.videoLoaded();
      }
    },
    togglePopup(minimized) {
      this.minimized = minimized;
    },
    onVideoEnded() {
      console.log("Video ended");
      this.videoEnded = true;

      if (this.testEnded) {
        this.close();
      }
    },
    close(force = false) {
      this.testEnded = true;
      if (this.videoEnded || force) {
        console.log("Close test");
        if (this.resolveDialog) {
          this.resolveDialog();
        }
        setTimeout(() => {
          this.video = null;
          this.videoLoaded = null;
          this.resolveDialog = null;
          this.title = null;
          this.body = null;
          this.slideBody = 0;
          this.showVideo = false;
          this.videoEnded = false;
          this.testEnded = false;
          this.open = false;
        });
      }
    },
    startTest({ resolve, title, body, video }) {
      this.resolveDialog = resolve;
      this.title = title;
      this.body = body;
      this.video = require(`../../assets/videos/test/${this.lab}/${video}.mp4`);
      this.open = true;
      console.log("Show test dialog");
    },
    closeClick() {
      const video = this.$refs.video;
      if (video) {
        video.pause();
      }

      setCancelAnimation();

      this.close();
    },
  },
};
</script>
<style lang="scss" scoped>
.test {
  position: relative;
  z-index: 5;
  width: 100vw;
  height: 100vh;
  pointer-events: none;

  .video {
    position: absolute;
    width: 50vw;
    max-width: 800px;
    bottom: 50px;
    left: 50px;
    opacity: 0.9;
  }
}
</style>
